import Container from 'components/Container.jsx';
import Glyph from 'components/Glyph.jsx';
import React from 'react';

import cx from 'classnames';
import './styles/DropZoneModal.scss';

class DropZoneModal extends React.Component {
  static propTypes = {
    /** @type {Boolean} Whether the single attachment slot is taken */
    isFileUploaded: React.PropTypes.bool,
    isHovering: React.PropTypes.bool,
    title: React.PropTypes.string,
    titleDrop: React.PropTypes.string,
  };

  render() {
    let content;
    if (!this.props.isFileUploaded) {
      content = {
        containerClass: 'DropZoneModal-drop',
        glyphName: 'upload',
        glyphColor: 'brand',
      };
      if (this.props.isHovering) {
        content.title = this.props.titleDrop || 'Drop attachment!';
      } else {
        content.title = this.props.title || 'Drag and drop attachment to upload';
      }
    } else {
      content = {
        containerClass: 'DropZoneModal-noDrop',
        glyphName: 'disabled',
        glyphColor: 'lava',
        title: 'Sorry, you can only upload 1 attachment.',
      };
    }

    return (
      <div
        {...this.props}
        className={cx('DropZoneModal', {
          hover: this.props.isHovering && !this.props.isFileUploaded,
        })}>
        <div className="DropZoneModal-wrap">
          <Container className={cx('DropZoneModal-container', content.containerClass)}>
            <header className="DropZoneModal-header">
              <Glyph
                className="DropZoneModal-glyph"
                name={content.glyphName}
                color={content.glyphColor}
                size="xxlarge"
              />
              <h2 className="DropZoneModal-title">{content.title}</h2>
            </header>
          </Container>
        </div>
      </div>
    );
  }
}

export default DropZoneModal;



// WEBPACK FOOTER //
// ./src/components/DropZoneModal.jsx